/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Pain_TypeInputs */

const en_us2_workout_after_pain_type = /** @type {(inputs: Workout_After_Pain_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What was the pain like?`)
};

const pt_br2_workout_after_pain_type = /** @type {(inputs: Workout_After_Pain_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é a dor?`)
};

const es_419_workout_after_pain_type = /** @type {(inputs: Workout_After_Pain_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo fue el dolor?`)
};

const pt_pt2_workout_after_pain_type = /** @type {(inputs: Workout_After_Pain_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é a dor?`)
};

const fr_fr2_workout_after_pain_type = /** @type {(inputs: Workout_After_Pain_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'était quel genre de douleur ?`)
};

const de_de2_workout_after_pain_type = /** @type {(inputs: Workout_After_Pain_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie war der Schmerz?`)
};

const it_it2_workout_after_pain_type = /** @type {(inputs: Workout_After_Pain_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Com'era il dolore?`)
};

/**
* | output |
* | --- |
* | "What was the pain like?" |
*
* @param {Workout_After_Pain_TypeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_pain_type = /** @type {((inputs?: Workout_After_Pain_TypeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Pain_TypeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_pain_type(inputs)
	if (locale === "es-419") return es_419_workout_after_pain_type(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_pain_type(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_pain_type(inputs)
	if (locale === "de-DE") return de_de2_workout_after_pain_type(inputs)
	if (locale === "it-IT") return it_it2_workout_after_pain_type(inputs)
	return en_us2_workout_after_pain_type(inputs)
});
export { workout_after_pain_type as "workout-after.pain_type" }